import React from "react";
import { Container } from "react-bootstrap";
import ListView from "../../../components/listView/ListView";
import faqTypeListViewMeta from "../../../configs/meta/listViewMeta/faqTypeListViewMeta";

const FaqType = () => (
  <React.Fragment>
    <Container fluid className="p-0">
      <ListView meta={faqTypeListViewMeta()} title="Faq Type List" />
    </Container>
  </React.Fragment>
);

export default FaqType;
